/**
 * @generated SignedSource<<9ea01f409a7a13b5ff743e8da6c525a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sideNavFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"sideNavBottomLinksFragment">;
  readonly " $fragmentType": "sideNavFragment";
};
export type sideNavFragment$key = {
  readonly " $data"?: sideNavFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"sideNavFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "sideNavFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "sideNavBottomLinksFragment"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "0605e7214954f19eefdf20e7c1323495";

export default node;
